import { render, staticRenderFns } from "./GenericInput.vue?vue&type=template&id=ccfe54e4&"
import script from "./GenericInput.vue?vue&type=script&lang=js&"
export * from "./GenericInput.vue?vue&type=script&lang=js&"
import style0 from "./GenericInput.vue?vue&type=style&index=0&id=ccfe54e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports